import React from "react";
import TranslationWrapper from "../../../../../components/TranslationWrapper/TranslationWrapper.tsx";
import { FormLabel } from "@mui/material";
import { Clear } from "@mui/icons-material";
import Button from "../../../../../components/CustomButtons/Button";
import CustomInput from "../../../../../components/CustomInput/CustomInput";
import SaveButton from "../../../../../components/CustomInput/SaveButton";
import GridContainer from "../../../../../components/Grid/GridContainer";
import GridItem from "../../../../../components/Grid/GridItem";

class Headers extends React.Component {
  state = {
    output: {
      name: "",
      value: "",
      ...this.props.value,
    },
    errors: [],
  };

  save = (e) => {
    e.preventDefault();
    let row = { ...this.state.output };

    /**
     * Hacky omdat ik anders de oude value niet meer weer even toevoegen aan de onsave
     */
    if (this.props.value !== undefined) {
      row.oldName = this.props.value.name;
    }

    let newErrors = [];

    if (this.props.methods?.map((method) => method.name).includes(this.state.output.name)) {
      newErrors.push("name");
    }

    if (newErrors.length < 1) {
      this.props.onSave(row);
      this.props.closeForm();
    } else {
      this.setState({ ...this.state, errors: newErrors });
    }
  };

  handleInputChange = (name, value) => {
    let newOutput = { ...this.state.output };
    newOutput[name] = value;
    this.setState({ output: newOutput });
  };

  handleCheckbox = (name) => (event) => {
    let newOutput = { ...this.state.output };
    newOutput[name] = event.target.checked;
    this.setState({ output: newOutput });
  };

  render() {
    return (
      <div style={{ background: "#f9f9f9", padding: "10px" }}>
        <GridContainer>
          <GridItem sm={2} xs={12}>
            <FormLabel>
              <TranslationWrapper tDefault={"Name"} tKey={"vestigingen.form.customfields.text.label.name"} />
            </FormLabel>
          </GridItem>
          <GridItem sm={10} xs={12}>
            <CustomInput
              error={this.state.errors.includes("name")}
              formControlProps={{
                fullWidth: true,
              }}
              helperText={this.state.errors.includes("name") ? "Description must be unique" : ""}
              id={"name"}
              inputProps={{
                type: "text",
                value: this.state.output.descr,
                onChange: (e) => this.handleInputChange("name", e.target.value),
              }}
            />
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem sm={2} xs={12}>
            <FormLabel>
              <TranslationWrapper tDefault={"Value"} tKey={"vestigingen.form.customfields.text.label.value"} />
            </FormLabel>
          </GridItem>
          <GridItem sm={10} xs={12}>
            <CustomInput
              formControlProps={{
                fullWidth: true,
              }}
              id={"value"}
              inputProps={{
                type: "text",
                value: this.state.output.code,
                onChange: (e) => this.handleInputChange("value", e.target.value),
              }}
            />
          </GridItem>
        </GridContainer>
        <GridContainer justify={"flex-end"} style={{ marginBottom: "-10px" }}>
          <GridItem>
            <Button color={"danger"} onClick={this.props.closeForm}>
              <Clear /> <TranslationWrapper tDefault={"Annuleren"} tKey={"global.button.annuleren"} />
            </Button>
            <SaveButton
              buttonText={
                this.props.value === undefined ? (
                  <TranslationWrapper tDefault={"Opslaan"} tKey={"global.button.opslaan"} />
                ) : (
                  <TranslationWrapper tDefault={"Aanpassen"} tKey={"global.button.aanpassen"} />
                )
              }
              hasError={false}
              onClick={this.save}
              saving={false}
            />
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export default Headers;
